module.exports = __webpack_public_path__ + "img/02.c1b9aa77.png";